import React from "react";
import { Linkedin, Instagram, Youtube } from "lucide-react";

export interface FooterLink {
  label: string;
  path: string;
}

export interface FooterSection {
  title: string;
  items: FooterLink[];
}

// Main navigation for the footer
export const footerNavigation: FooterSection[] = [
  {
    title: "Angebote",
    items: [
      { label: "Coaching", path: "/coaching" },
      { label: "Consulting", path: "/consulting" },
      { label: "Outdoor-Coaching", path: "/outdoor-coaching" },
      { label: "Coaching Nürnberg", path: "/coaching-nuernberg" },
      { label: "Preise", path: "/preise" },
    ],
  },
  {
    title: "Über mich",
    items: [
      { label: "Meine Geschichte", path: "/ueber-mich" },
      { label: "Blog", path: "/blog" },
      { label: "FAQ", path: "/faq" },
      { label: "Kontakt", path: "/kontakt" },
    ],
  },
  {
    title: "Rechtliches",
    items: [
      { label: "Impressum", path: "/impressum" },
      { label: "Datenschutz", path: "/datenschutz" },
      { label: "AGB", path: "/agb" },
      { label: "Rechtlicher Hinweis", path: "/rechtlicher-hinweis" },
      { label: "Mustervertrag (Verbraucher)", path: "/mustervertrag-verbraucher" },
      { label: "Mustervertrag (Unternehmer)", path: "/mustervertrag-unternehmer" },
    ],
  },
];

export const secondaryLinks: FooterLink[] = [
  { label: "Impressum", path: "/impressum" },
  { label: "Datenschutz", path: "/datenschutz" },
  { label: "AGB", path: "/agb" },
];

export const rechtlichesLinks: FooterLink[] = [
  { label: "Impressum", path: "/impressum" },
  { label: "Datenschutz", path: "/datenschutz" },
  { label: "AGB", path: "/agb" },
  { label: "Mustervertrag (Verbraucher)", path: "/mustervertrag-verbraucher" },
  { label: "Mustervertrag (Unternehmer)", path: "/mustervertrag-unternehmer" },
];

export const socialLinks = [
  {
    name: "LinkedIn",
    url: "https://linkedin.com/in/joerg-hoermann",
    icon: Linkedin,
    color: "#0077B5",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/joerg_hoermann/",
    icon: Instagram,
    color: "#E4405F",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@Hoermann_Coaching_Consulting",
    icon: Youtube,
    color: "#FF0000",
  },
];

export const faqItems = [
  {
    question: "Was ist Finanzcoaching?",
    answer: "Finanzcoaching ist eine Begleitung, bei der ich Ihnen helfe, Ihre finanzielle Situation zu verstehen, Ziele zu setzen und diese zu erreichen. Im Gegensatz zur Finanzberatung geht es nicht um Produktempfehlungen, sondern um die Entwicklung Ihrer finanziellen Kompetenz.",
  },
  {
    question: "Wie unterscheidet sich Coaching von Beratung?",
    answer: "Beim Coaching stehen Sie im Mittelpunkt. Ich gebe keine direkten Lösungen vor, sondern unterstütze Sie dabei, eigene Lösungen zu finden. Beratung hingegen bietet konkrete Empfehlungen und Lösungsvorschläge an.",
  },
  {
    question: "Wie lange dauert eine Coaching-Einheit?",
    answer: "Eine typische Coaching-Sitzung dauert 60 bis 90 Minuten. Je nach Thema und Bedarf können wir aber auch kürzere oder längere Einheiten vereinbaren.",
  },
];

export const constants = {
  bookingUrl: "https://zeeg.me/joerghoermann",
};

export const navColumns = footerNavigation;

export default footerNavigation;
